export enum SortBy {
  /* Lines Table */
  SYSTEM_ID = 'SYSTEM_ID',
  HOST_TYPE = 'HOST_TYPE',
  HOST_ID = 'HOST_ID',
  PARTIAL_FULFILLMENT = 'PARTIAL_FULFILLMENT',

  /* Products Table */
  PRODUCT = 'PRODUCT',
  LICENSE_MODEL = 'LICENSE_MODEL',
  LICENSE_TYPE = 'LICENSE_TYPE',
  LICENSE_EXPIRY = 'LICENSE_EXPIRY',
  SUPPORT_EXPIRY = 'SUPPORT_EXPIRY',
  QUANTITY = 'QUANTITY',

  /* Organizations Table */
  ORGANIZATION = 'ORGANIZATION',
  DEAL = 'DEAL',
  DEAL_TYPE = 'DEAL_TYPE',
  RENEWAL_DATE = 'RENEWAL_DATE'
}

export enum SortOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export enum SortView {
  DEALS,
  LINES,
  SYSTEMS
}

export interface SortData {
  order: SortOrder
  sortBy: SortBy
}

export interface SortViewData {
  [SortView.DEALS]: SortData,
  [SortView.LINES]: SortData,
  [SortView.SYSTEMS]: SortData,
}

export function initialSortViewData(): SortViewData {
  return {
    [SortView.DEALS]: { order: SortOrder.DESCENDING, sortBy: SortBy.DEAL },
    [SortView.LINES]: { order: SortOrder.DESCENDING, sortBy: SortBy.PRODUCT },
    [SortView.SYSTEMS]: { order: SortOrder.DESCENDING, sortBy: SortBy.SYSTEM_ID },
  }
}